"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Instagram, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";
const productLinks = [{
  label: "Wellbeing Risk Radar",
  to: "/WellbeingRiskRadarPage"
}, {
  label: "Services",
  to: "/ServicesPage"
}, {
  label: "Workshops",
  to: "#"
}];
const companyLinks = [{
  label: "About Us",
  to: "/AboutPage"
}, {
  label: "How I Work",
  to: "#"
}, {
  label: "Contact",
  to: "/ContactPage"
}];
const resourceLinks = [{
  label: "Blog",
  to: "#"
}, {
  label: "Case Studies",
  to: "#"
}, {
  label: "FAQ",
  to: "#"
}];
const legalLinks = [{
  label: "Privacy Policy",
  to: "#"
}, {
  label: "Terms of Service",
  to: "#"
}, {
  label: "Cookie Policy",
  to: "#"
}];
const socialLinks = [{
  icon: Linkedin,
  to: "#",
  label: "LinkedIn"
}, {
  icon: Instagram,
  to: "#",
  label: "Instagram"
}];
export default function MultiColumnFooter() {
  return <section id="multicolumnfooter" className="bg-secondary text-secondary-foreground py-16 lg:py-20">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/" className="inline-block">
              <img src="/img/feel_good_works_logo_white.png" alt="Feel Good Works" className="h-7 w-auto" />
            </Link>
            <p className="text-sm font-sans leading-relaxed text-secondary-foreground/90 max-w-xs">
              Empowering workplaces through holistic wellbeing strategies that
              foster resilience, engagement, and a thriving company culture.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-8 sm:flex-row sm:gap-16 lg:flex-col lg:gap-8">
            <div className="flex flex-col gap-4">
              <h4 className="font-default font-bold text-lg tracking-wide">
                Product
              </h4>
              <ul className="flex flex-col gap-3">
                {productLinks.map((link, i) => <li key={i} data-index={i}>
                    <Link to={link.to} className="text-sm font-sans text-secondary-foreground/80 transition-colors hover:text-ring">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>
            <div className="flex flex-col gap-4">
              <h4 className="font-default font-bold text-lg tracking-wide">
                Company
              </h4>
              <ul className="flex flex-col gap-3">
                {companyLinks.map((link, i) => <li key={i} data-index={i}>
                    <Link to={link.to} className="text-sm font-sans text-secondary-foreground/80 transition-colors hover:text-ring">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-8 sm:flex-row sm:gap-16 lg:flex-col lg:gap-8">
            <div className="flex flex-col gap-4">
              <h4 className="font-default font-bold text-lg tracking-wide">
                Resources
              </h4>
              <ul className="flex flex-col gap-3">
                {resourceLinks.map((link, i) => <li key={i} data-index={i}>
                    <Link to={link.to} className="text-sm font-sans text-secondary-foreground/80 transition-colors hover:text-ring">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>
            <div className="flex flex-col gap-4">
              <h4 className="font-default font-bold text-lg tracking-wide">
                Legal
              </h4>
              <ul className="flex flex-col gap-3">
                {legalLinks.map((link, i) => <li key={i} data-index={i}>
                    <Link to={link.to} className="text-sm font-sans text-secondary-foreground/80 transition-colors hover:text-ring">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h4 className="font-default font-bold text-lg tracking-wide">
              Contact Us
            </h4>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3 text-sm font-sans text-secondary-foreground/90">
                <Phone className="size-5 shrink-0 text-ring" />
                <span>+44 7543 168598</span>
              </li>
              <li className="flex items-start gap-3 text-sm font-sans text-secondary-foreground/90">
                <Mail className="size-5 shrink-0 text-ring" />
                <Link to="mailto:hello@feelgoodworks.co.uk" className="transition-colors hover:text-ring">info@feelgoodworks.co.uk</Link>
              </li>
              <li className="flex items-start gap-3 text-sm font-sans text-secondary-foreground/90">
                <MapPin className="size-5 shrink-0 text-ring" />
                <span>85 Great Portland Street<br />London W1W 7LT, UK</span>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="my-12 bg-secondary-foreground/20" />

        {}
        <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
          <div className="flex items-center gap-4">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link key={i} data-index={i} to={social.to} className="flex size-10 items-center justify-center rounded-lg bg-chart-3 text-secondary-foreground transition-colors hover:bg-ring" title={social.label}>
                  <Icon className="size-5" />
                </Link>;
          })}
          </div>
          <p className="text-xs font-sans text-secondary-foreground/60 text-center md:text-left">
            © {new Date().getFullYear()} Feel Good Works. All rights reserved.
          </p>
        </div>
      </div>
    </section>;
}